// import { applyMiddleware, combineReducers, createStore } from "redux";
// import { thunk } from "redux-thunk";
// import { loginReducer } from "./user/reducer";


// export const rootReducer = combineReducers({
//     login: loginReducer,
//     // products: productsReducer,
//     // cart_products: cartProductsReducer,
//     // wishlistProducts: wishlistProductsReducer,
//     // searchProducts: searchProductsReducer,
//     // visitURL: visitURLReducer,
//     // address: addressReducer,
//     // orderProducts: orderProductsReducer
// })

// export const store = createStore(rootReducer, applyMiddleware(thunk))



// redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { loginReducer } from "./user/reducer";

export const store = configureStore({
  reducer: {
    login: loginReducer,
  },
});


// Optional: handy types if you’re using TypeScript
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
